import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'form-card-button',
  standalone: true,
    imports: [NgOptimizedImage],
  templateUrl: './form-card-button.component.html',
  styleUrl: './form-card-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormCardButtonComponent {
    subtitle = input.required<string>();
    danger = input(false);
    transparent = input(false);
    onClick = output<void>();
}
